<fin-booking-widget-selector
  class="flex flex-1"
  [label]="'aurinkomatkat.duration' | finLocalization"
  [disabled]="disabled()"
  [position]="'left'"
  (click)="openModal()"
  data-testid="am-duration-selector"
>
  <div class="flex flex--middle">
    @if (!selectedDuration()) {
      <span>{{ 'aurinkomatkat.selectDuration' | finLocalization }}</span>
    }
    @if (selectedDuration()) {
      <span>{{ selectedDuration().label }}</span>
    }
  </div>
</fin-booking-widget-selector>

<fcom-modal
  [(open)]="modalOpen"
  [title]="'aurinkomatkat.selectDuration' | finLocalization"
  [fitToContent]="true"
  data-testid="am-duration-selector-modal"
>
  <ul class="flex flex--column pr-large-x nordic-blue-900-text text-icon-primary" tabindex="-1">
    @for (duration of durationOptions(); track duration.code; let last = $last) {
      <li class="flex flex--column" [ngClass]="{ 'border-bottom': !last }">
        <button
          [attr.data-testid]="'duration-option-' + duration.code"
          class="flex flex--space-between fill ps-medium-y"
          role="option"
          [attr.aria-selected]="selectedDuration()?.code === duration.code"
          (click)="onDurationSelect(duration)"
        >
          <span class="font-body-1 font-body-medium">{{ duration.label }}</span>
          @if (selectedDuration()?.code === duration.code) {
            <span class="inline-block ms-xsmall-r">
              <fcom-icon class="icon-medium" [name]="SvgLibraryIcon.CHECKMARK" />
            </span>
          }
        </button>
      </li>
    }
  </ul>
</fcom-modal>
